import EligibilityActionTypes from './types';

export const fetchRuleSets = (applicationId) => ({
  type: EligibilityActionTypes.FETCH_RULE_SETS,
  payload: { applicationId },
});

export const fetchRuleSetsSuccess = (payload) => ({
  type: EligibilityActionTypes.FETCH_RULE_SETS_SUCCESS,
  payload,
});

export const fetchRuleSetsFailure = (payload) => ({
  type: EligibilityActionTypes.FETCH_RULE_SETS_FAILURE,
  payload,
});

export const saveRuleSet = (applicationId, data, ruleSetId, cb) => ({
  type: EligibilityActionTypes.SAVE_RULE_SET,
  payload: { applicationId, data, ruleSetId, cb },
});

export const saveRuleSetSuccess = (payload) => ({
  type: EligibilityActionTypes.SAVE_RULE_SET_SUCCESS,
  payload,
});

export const saveRuleSetFailure = (payload) => ({
  type: EligibilityActionTypes.SAVE_RULE_SET_FAILURE,
  payload,
});

export const deleteRuleSet = (applicationId, ruleSetId, cb) => ({
  type: EligibilityActionTypes.DELETE_RULE_SET,
  payload: { applicationId, ruleSetId, cb },
});

export const deleteRuleSetSuccess = (payload) => ({
  type: EligibilityActionTypes.DELETE_RULE_SET_SUCCESS,
  payload,
});

export const deleteRuleSetFailure = (payload) => ({
  type: EligibilityActionTypes.DELETE_RULE_SET_FAILURE,
  payload,
});

export const previewEligibility = (applicationId, data, cb) => ({
  type: EligibilityActionTypes.PREVIEW_ELIGIBILITY,
  payload: { applicationId, data, cb },
});

export const previewEligibilitySuccess = (payload) => ({
  type: EligibilityActionTypes.PREVIEW_ELIGIBILITY_SUCCESS,
  payload,
});

export const previewEligibilityFailure = (payload) => ({
  type: EligibilityActionTypes.PREVIEW_ELIGIBILITY_FAILURE,
  payload,
});

export const clearEligibilityPreview = () => ({
  type: EligibilityActionTypes.CLEAR_PREVIEW,
});
